import { useCallback } from 'react'
import { TargetPestDataType } from './useData'
import { useFormikContext } from 'formik'
import { IAddOpportunityFormModel } from '@user/components/Opportunities/AddOpportunityPage/typings'

export function useHandlers() {
  const { setFieldValue } = useFormikContext<IAddOpportunityFormModel>()

  const handelChange = useCallback((value: TargetPestDataType[] | null) => {
    setFieldValue(
      'targetPests',
      value?.map((row) => row.value),
    )
  }, [])

  return {
    handelChange,
  }
}
